import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { FacilityCard } from "@/components/FacilityCard";
import { FacilityDetailPanel } from "@/components/FacilityDetailPanel";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Heart } from "lucide-react";

export default function FavoritesPage() {
  const { user, refresh } = useAuth();
  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/favorites"); setFacilities(data); }
    catch { setFacilities([]); }
    finally { setLoading(false); }
  };
  useEffect(() => { if (user) load(); else setLoading(false); }, [user]);

  const toggleFavorite = async (f) => {
    try { await api.post(`/favorites/${f.facility_id}`); await refresh(); load(); }
    catch { toast.error("Could not update"); }
  };

  return (
    <div className="min-h-screen bg-[#F7F6F2]">
      <Header />
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-10">
        <h1 className="font-heading text-3xl font-medium text-[#1C211F] mb-2">Saved facilities</h1>
        <p className="text-[#4A534E] mb-8">Facilities you've bookmarked for your search.</p>

        {!user && (
          <div className="text-center py-20 text-[#5C6660]">Please log in to view your saved facilities.</div>
        )}
        {user && !loading && facilities.length === 0 && (
          <div className="text-center py-20">
            <Heart className="h-10 w-10 text-[#0077B6] mx-auto mb-3" />
            <p className="text-[#4A534E] mb-4">You haven't saved any facilities yet.</p>
            <Link to="/search"><Button className="bg-[#1A365D] hover:bg-[#12283F] text-white rounded-xl">Find care</Button></Link>
          </div>
        )}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5" data-testid="favorites-grid">
          {facilities.map((f) => (
            <FacilityCard key={f.facility_id} facility={f} isFavorite
              onSelect={(x) => { setSelected(x); setDetailOpen(true); }} onToggleFavorite={toggleFavorite} />
          ))}
        </div>
      </div>
      <FacilityDetailPanel facility={selected} open={detailOpen} onOpenChange={setDetailOpen}
        isFavorite onToggleFavorite={toggleFavorite} />
    </div>
  );
}
